import React, { useEffect } from "react";
import WhatsOn from "../aat/components/WhatsOn/WhatsOn";
import { AppState, AppThunkDispatch } from "../store";
import { getShows } from "../store/shows";
import { thunkUpdateShows } from "../store/shows/action";
import { connect } from "react-redux";
import { showTicketsAsync } from "../store/basm/action";

const Shows: React.FunctionComponent<StateProps> = (props) =>
{
    const { updateShows } = props;

    useEffect(() =>
    {
        updateShows();
    }, [updateShows]);

    const handleBuyClicked = (eventNo: number, showNo?: number) =>
    {
        props.showTickets(eventNo, showNo);
    };

    return <div className="w-full py-8 sm:py-12">
        <div className="container mx-auto px-4">
            <WhatsOn buyOnClick={handleBuyClicked} />
        </div>
    </div>;
};

const mapStateToProps = (state: AppState) =>
{
    return {
        shows: getShows(state.shows)
    };
};

const mapToDispatchProps = (dispatch: AppThunkDispatch) =>
    ({
        updateShows: () => dispatch(thunkUpdateShows()),
        showTickets: (eventNo: number, showNo?: number) => dispatch(showTicketsAsync(eventNo, showNo))
    });

type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapToDispatchProps>;

export default connect(mapStateToProps, mapToDispatchProps)(Shows);
